import { Suspense, lazy } from 'react';
import { Spinner } from './ui.jsx';

// Leaflet and its stylesheet are the largest thing in the bundle and most visits
// never open a map, so the real component is pulled in on demand.
const MapView = lazy(() => import('./MapView.jsx'));

const MapPanel = (props) => (
  <Suspense fallback={<div className="map-loading" style={{ height: props.height ?? 480 }}><Spinner label="Loading the map" /></div>}>
    <MapView {...props} />
  </Suspense>
);

export default MapPanel;
